import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Col, Row } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import { IdGen } from 'utils'

import * as AsientosContablesService from 'services/asientosContables.service'

import BuscadorInput from './buscador'
import DetallesMovimiento from './detalle'

const portletBreadcrumbs = [
  { name: 'Asientos Contables', path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}` },
  { name: 'Reportes' },
  { name: 'Análisis de Balance' }
]

const AnalisisBalancePage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [infoBalance, setInfoBalance] = React.useState([])

  const textoBuscadoRef = React.useRef('')

  const buscarPorFiltro = React.useCallback(
    busqueda => {
      setInfoBalance([])

      if (!busqueda) {
        __zariContext.snack('error', 'Ingresar texto para busqueda.')
        return
      }

      textoBuscadoRef.current = busqueda

      AsientosContablesService.obtenerBalancexCuenta(textoBuscadoRef.current)
        .then(({ data }) => {
          console.log(data)
          setInfoBalance(data)
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
    },
    [__zariContext]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Análisis de Balance' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row className='zari-slim-form'>
            <Col md={6}>
              <BuscadorInput buscarPorFiltro={buscarPorFiltro} />
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      {infoBalance.length > 0 && (
        <>
          <Portlet>
            <Portlet.Body>
              <Row>
                <Col className='text-left' md={12}>
                  <table border='1' width='100%'>
                    <tr>
                      <td colSpan='2' className='text-center'>
                        CUENTA O SUBCUENTA CONTABLE
                      </td>
                      <td colSpan='2' className='text-center'>
                        SALDOS INICIALES
                      </td>
                      <td colSpan='2' className='text-center'>
                        MOVIMIENTOS
                      </td>
                      <td colSpan='2' className='text-center'>
                        SALDOS FINALES
                      </td>
                    </tr>
                    <tr>
                      <td className='text-center'>Código</td>
                      <td className='text-center'>Denominación</td>
                      <td className='text-center'>Deudor</td>
                      <td className='text-center'>Acreedor</td>
                      <td className='text-center'>Debe</td>
                      <td className='text-center'>Haber</td>
                      <td className='text-center'>Deudor</td>
                      <td className='text-center'>Acreedor</td>
                    </tr>
                    {infoBalance.map((item, index, key) => {
                      return <DetallesMovimiento key={IdGen.newId()} item={item} index={index} />
                    })}
                  </table>
                </Col>
              </Row>
            </Portlet.Body>
          </Portlet>
        </>
      )}
    </>
  )
}

export default React.memo(AnalisisBalancePage)
